import { render, staticRenderFns } from "./CardTarjaEnqueteSaiaJusta.vue?vue&type=template&id=5b825e64&scoped=true"
import script from "./CardTarjaEnqueteSaiaJusta.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSaiaJusta.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSaiaJusta.vue?vue&type=style&index=0&id=5b825e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b825e64",
  null
  
)

export default component.exports